import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { ReputationCard } from '../../components/Reputation/ReputationCard';
import { GET_USER_BY_USERNAME_QUERY } from '../../graphql/resolvers/userQueries/getUserByUsername.gql';
import {
  type ReputationLike,
  useLiveReputation,
} from '../../hooks/useLiveReputation';
import './PublicProfile.scss';

function initials(name: string): string {
  return name.slice(0, 2).toUpperCase();
}

export default function UserPublicProfile() {
  const { username = '' } = useParams<{ username: string }>();

  const { data, loading } = useQuery(GET_USER_BY_USERNAME_QUERY, {
    variables: { username },
    skip: !username,
  });

  const user = data?.getUserByUsername;
  const reputation = useLiveReputation(
    user?.id,
    user?.reputation as unknown as ReputationLike | undefined,
  );

  if (loading) {
    return (
      <section className="public-profile">
        <p className="public-profile__status">Loading…</p>
      </section>
    );
  }

  if (!user) {
    return (
      <section className="public-profile">
        <p className="public-profile__status">No user found for @{username}.</p>
      </section>
    );
  }

  return (
    <section className="public-profile">
      <header className="public-profile__head">
        <div className="public-profile__avatar" aria-hidden="true">
          {initials(username)}
        </div>
        <h1 className="public-profile__name">@{username}</h1>
      </header>
      <ReputationCard
        username={username}
        reputation={reputation}
        variant="credential"
      />
    </section>
  );
}
